module.exports = __webpack_public_path__ + "img/WF_19_sm.1c13d8ed.jpg";